import { ref } from 'vue'

const isMessengerOpen = ref(false)
let hasBoundMessengerEvents = false

const callZendesk = (...args) => {
  if (typeof window === 'undefined' || typeof window.zE !== 'function') {
    return false
  }

  window.zE(...args)
  return true
}

const bindMessengerEvents = () => {
  if (hasBoundMessengerEvents || typeof window === 'undefined' || typeof window.zE !== 'function') {
    return
  }

  window.zE('messenger:on', 'open', () => {
    isMessengerOpen.value = true
  })

  window.zE('messenger:on', 'close', () => {
    isMessengerOpen.value = false
  })

  hasBoundMessengerEvents = true
}

export const useZendeskMessenger = () => {
  bindMessengerEvents()

  const showMessenger = () => callZendesk('messenger', 'show')
  const hideMessenger = () => {
    isMessengerOpen.value = false
    return callZendesk('messenger', 'hide')
  }
  const setCustomization = (theme) => {
    if (!theme || typeof theme !== 'object') {
      return false
    }

    return callZendesk('messenger:set', 'customization', theme)
  }
  const setZIndex = (zIndex) => {
    if (typeof zIndex !== 'number' || Number.isNaN(zIndex)) {
      return false
    }

    return callZendesk('messenger:set', 'zIndex', zIndex)
  }

  return {
    isMessengerOpen,
    showMessenger,
    hideMessenger,
    setCustomization,
    setZIndex,
  }
}
